import JSONAPIClient from '../../JSONAPIClient'

JSONAPIClient.define('credit_liability', {
  aus_scenario_answer_id: '',
  aus_setting_id: '',
  credit_task_id: '',
  credit_liability_id: '',
})
